var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNonprofitColored = function SvgNonprofitColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703,
    d: "m14.212 13.387-4.197-3.883c-2.288-2.298 1.05-6.748 4.197-3.148 3.149-3.589 6.518.86 4.198 3.148zM10.678 18.637c.516.258 2.28.774 3.097.774 1.806 0 2.394-.318 3.097-.516 1.032-.292 1.458-.997 1.568-1.324m0 0c.074-.223.125.276 0-.225-.517-2.064-2.6-.291-4.665-.55-2.065-.257-4.646-1.514-5.678-1.514S5 16.022 5 17.346c0 1 .774 2.065 2.065 3.064s3.87 1.806 6.452 1.806c3.145 0 4.645-1.066 5.935-1.806.448-.257 3.613-2.84 3.871-3.613.333-1-.234-1.311-.774-1.515-.774-.292-1.419.5-2.064.999-1.29.999-1.29 1.066-2.045 1.29"
  })));
};
export default SvgNonprofitColored;